// src/StarFill.tsx
import * as React from "react";
var StarFill = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M9.9 12.53c.06-.04.14-.04.2 0l3.77 2.41c.28.18.64-.07.57-.4l-1.01-4.58c-.01-.07.01-.13.06-.18l3.39-3.1c.24-.22.11-.62-.22-.65l-4.43-.4a.199.199 0 0 1-.16-.12l-1.72-4.27a.38.38 0 0 0-.7 0L7.93 5.51c-.02.06-.08.11-.15.12l-4.44.4c-.32.03-.46.43-.22.65l3.38 3.1c.05.05.08.12.06.18l-1.01 4.58c-.07.33.29.58.57.4l3.78-2.41z" })
);
StarFill.displayName = "StarFill";
export {
  StarFill
};
